import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';
import type { Trace } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { normalizeAutoActionApprovalStreamMessage } from './normalizeAutoActionApprovalStreamMessage';

export const processAutoActionApprovalStreamMessage = ({
	streamMessage,
	conversationId,
	existingTraces,
	updateTraces,
	sendAnalyticsEvent,
}: {
	streamMessage: unknown;
	conversationId: string;
	existingTraces: Trace[];
	updateTraces: (traces: Trace[]) => void;
	sendAnalyticsEvent: (payload: AnalyticsEventPayload) => void;
}): boolean => {
	const result = normalizeAutoActionApprovalStreamMessage(streamMessage);
	if (result.kind === 'not-auto-action-approval') {
		return false;
	}

	if (result.kind === 'malformed') {
		sendAnalyticsEvent({
			eventType: 'track',
			action: 'errored',
			actionSubject: 'autoActionApproval',
			actionSubjectId: 'rovoChatAutoActionApprovalStream',
			attributes: {
				conversationChannelId: conversationId,
				messageType: 'AUTO_ACTION_APPROVAL',
			},
		});
		return true;
	}

	updateTraces([...existingTraces, result.trace]);
	sendAnalyticsEvent({
		eventType: 'track',
		action: result.analytics.action,
		actionSubject: 'autoActionApproval',
		actionSubjectId: 'rovoChatAutoActionApprovalStream',
		attributes: {
			conversationChannelId: conversationId,
			...result.analytics.attributes,
		},
	});
	return true;
};
